<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted(){
      // 通过监听hashchange事件 判断当前页面的路由与实际的路由是否一致
   window.addEventListener('hashchange', () => {
            let currPath = window.location.hash.slice(1)
            if (this.$route.path !== currPath) { // 不一致就跳转url的路由
                this.$router.push(currPath)
            }
    }, false)
  }
}

</script>

<style>
.line1{
  overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
}
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
.flex_nav{
  display: flex;
  justify-content: space-around;
}
.flex_end{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex{
  display: flex;
}
.flex_center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex_right{
  display: flex;
  justify-content: flex-end;
}
.flex_left{
  display: flex;
  justify-content: flex-end;
}
.content{
  width: 1200px;
  margin: 0 auto;
}

html {-webkit-text-size-adjust:none;-webkit-text-size-adjust: 100%;-ms-text-size-adjust: 100%;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);height: 100%;}
body {height: 100%;font-size: 16px; color: #fff;
background: #fff;min-height: 100%;font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;}
* {margin: 0;padding: 0;border: 0;}
ul,ul li,ol,li {list-style: none outside none;}
img {vertical-align: middle;border: none;width: 100%;}
i {font: inherit;}
input,select,option {vertical-align: middle;border-radius: 0px;-moz-appearance:none;-webkit-appearance:none;appearance:none;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);outline: none;}
input[type="text"],input[type="button"],input[type="submit"],input[type="reset"] {-webkit-appearance: none;appearance: none;border-radius: 0;outline: none;}
.fl {float: left;display: inline;}
.fr {float: right;display: inline;}
h1,h2,h3,h4,h5,h6,i,strong {font-weight: normal;}
select::-ms-expand { display: none; }
/* a {color: #fff;text-decoration: none;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);} */
a:hover {text-decoration: none;outline: none;}
.clear {clear: both;}
.clearfix:after {content: ".";display: block;height: 0;clear: both;visibility: hidden;}
.clearfix {zoom: 1;display: block;_height: 1px;clear: both;}
body,ul,ol,li,p,h1,h2,h3,h4,h5,h6,form,fieldset,table,td,img,div,dl,dt,dd,input{margin: 0;padding: 0;}
::-webkit-scrollbar {
	display:none
}
[v-cloak] {
   display: none;
}
.starts{
  position: relative;
}
.starts>label::before{
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue